var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPolygonLight = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 11,
    viewBox: "0 0 13 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.47361 7.7176L12.3842 6.0376C12.5396 5.9494 12.632 5.7814 12.632 5.605V2.245C12.632 2.0686 12.5354 1.9006 12.3842 1.8124L9.47361 0.132404C9.31821 0.0442037 9.12921 0.0442037 8.97381 0.132404L6.06321 1.8124C5.90781 1.9006 5.81541 2.0686 5.81541 2.245V8.251L3.77421 9.427L1.73301 8.251V5.8948L3.77421 4.7188L5.12241 5.4958V3.9166L4.02621 3.2824C3.95061 3.2404 3.86241 3.2152 3.77841 3.2152C3.69021 3.2152 3.60621 3.2362 3.53061 3.2824L0.620008 4.9624C0.464608 5.0506 0.372208 5.2186 0.372208 5.395V8.755C0.372208 8.9314 0.468808 9.0994 0.620008 9.1876L3.53061 10.8676C3.68601 10.9558 3.87501 10.9558 4.03041 10.8676L6.94101 9.1876C7.09641 9.0994 7.18881 8.9314 7.18881 8.755V2.749L7.22661 2.728L9.23001 1.573L11.2712 2.749V5.1052L9.23001 6.2812L7.88601 5.5042V7.0834L8.98221 7.7134C9.12921 7.81 9.32241 7.81 9.47361 7.7176Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPolygonLight);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/polygon-light.eeb70179ce80570ea29ef68edf450116.svg";